import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
import { notificationService } from '@/shared/services';
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsContainer',
  setup: function setup(__props) {
    defineComponent({
      name: 'NotificationsContainer'
    });
    var notificationsData = notificationService.notificationsData;
    return {
      __sfc: true,
      notificationsData: notificationsData
    };
  }
});